// Shared map constants

export const USA_BOUNDS = [
  [-126, 50.9],
  [-67.93, 23.3],
];

export const USA_CENTER = [-98.5795, 37.8283];

export const MARKETS_STYLE_URL = "mapbox://styles/lioneightdev/cm4zv8t6b00cj01sp11qp616w";

export const DEFAULT_PADDING = { top: 2, bottom: 2, left: 2, right: 2 };

export const DEFAULT_MAP_CONFIG = {
  dragRotate: false,
  touchZoomRotate: false,
  pitchWithRotate: false,
  dragPan: true,
  logoPosition: "bottom-right",
};
